<template>
<div>
  <div class="content-header row">
    <div class="content-header-left col-12 mb-2 mt-1">
      <div class="row breadcrumbs-top">
        <div class="col-12">
          <div class="card">
            <Alert :text="$t('enterprise_profile_email_validation')" type="danger" dismissable="false"
                   v-if="editable && inValidEmail" />
            <Alert :text="$t('enterprise_profile_phone_number_validation')" type="danger" dismissable="false"
                   v-if="editable && enterprisePhoneError" />
            <Alert :text="$t('enterprise_profile_street_one_name_validation')" type="danger" dismissable="false"
                   v-if="editable && streetNameOneError" />
            <Alert :text="$t('enterprise_profile_street_two_name_validation')" type="danger" dismissable="false"
                   v-if="editable && streetNameTwoError" />
            <Alert :text="$t('enterprise_profile_city_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseCityOneError" />
            <Alert :text="$t('enterprise_profile_state_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseStateOneError" />
            <Alert :text="$t('enterprise_profile_country_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseCountryOneError" />
            <Alert :text="$t('enterprise_profile_street_one_name_validation')" type="danger" dismissable="false"
                   v-if="editable && streetNameOneOptionalError" />
            <Alert :text="$t('enterprise_profile_street_two_name_validation')" type="danger" dismissable="false"
                   v-if="editable && streetNameTwoOptionalError" />
            <Alert :text="$t('enterprise_profile_city_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseCityOneOptionalError" />
             <Alert :text="$t('enterprise_profile_state_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseStateOneOptionalError" />
            <Alert :text="$t('enterprise_profile_country_name_validation')" type="danger" dismissable="false"
                   v-if="editable && enterpriseCountryOneOptionalError" />
            <Alert :text="$t('enterprise_profile_email_validation')" type="danger" dismissable="false"
                   v-if="editable && generalEmailError" />
            <Alert :text="$t('enterprise_profile_website_validation')" type="danger" dismissable="false"
                   v-if="editable && websiteError" />
            <Alert :text="$t('enterprise_profile_first_name_validation')" type="danger" dismissable="false"
                   v-if="editable && ownerFirstNameError" />
            <Alert :text="$t('enterprise_profile_last_name_validation')" type="danger" dismissable="false"
                   v-if="editable && ownerLastNameError" />
            <Alert :text="$t('enterprise_profile_language_validation')" type="danger" dismissable="false"
                   v-if="editable && languageError" />
            <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiError" />

            <div class="card-header headerDiv">
              <h5 class="contactHeading"> {{ $t('enterprise_profile_enterprise_business_address_heading') }} </h5>
              <div class="text-right editButtonAlign" v-if="!editable">
                <button type="button" class="btn btn-primary mb-1 mr-1"  @click="editEnterpriseProfile()">
                  <span class="">{{ $t('enterprise_profile_edit_button') }}</span>
                </button>
              </div>

            </div>
            <div class="card-content">
              <form action="">
                <div class="">
                  <div class="form-group row mx-1">
                    <div class="col-6">
                      <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_street_name_1_label')}}</label>
                      <input type="text" class="form-control height-50" v-model="streetNameOne" :disabled="isDisabled"
                             :class="editable && streetNameOneError ? 'errClass':''"/>
                    </div>
                    <div class="col-6">
                      <label for="street-name-2" class="fontStyle"> {{$t('enterprise_profile_street_name_2_label')}}</label>
                      <input type="text" class="form-control height-50" v-model="streetNameTwo" :disabled="isDisabled"
                             :class="editable && streetNameTwoError ? 'errClass':''"/>
                    </div>
                  </div>
                  <div class="form-group row mx-1">
                    <div class="col-6">
                      <div class="row">
                        <div class="col-6 pr-4">
                          <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_city_label')}}</label>
                          <input type="text" class="form-control height-50" v-model="enterpriseCityOne"  :disabled="isDisabled"
                                 :class="editable && enterpriseCityOneError ? 'errClass':''"/>
                        </div>
                        <div class="col-6">
                          <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_state_label')}}</label>
                          <input type="text" class="form-control height-50" v-model="enterpriseStateOne" :disabled="isDisabled"
                                 :class="editable && enterpriseStateOneError ? 'errClass':''"/>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="row">
                        <div class="col-6 pr-4">
                          <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_postal_code_label')}}</label>
                          <input type="text" class="form-control height-50" v-model="enterprisePostalCodeOne" :disabled="isDisabled"
                                 @keypress="validateNumber"/>
                        </div>
                        <div class="col-6">
                          <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_country_label')}}</label>
                          <select  class='form-control height-50' v-model="enterpriseCountryOne" :disabled="isDisabled" :class="editable && enterpriseCountryOneError ? 'errClass':''"
                                  >
                            <option value="default" disabled selected>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                            </option>
                            <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                                countryName(country)
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="headerDiv">
                  <h5 class="contactHeading tickMargin mt-3 mb-2"> <img :src="tickIcon" class="titleFont" alt="Tick image">
                    {{ $t('enterprise_profile_billing_address_heading') }}
                  </h5>
                  <div class="">
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_street_name_1_label')}}</label>
                        <input type="text" class="form-control height-50" v-model="streetNameOneOptional" :disabled="isDisabled"
                               :class="editable && streetNameOneOptionalError ? 'errClass':''"/>
                      </div>
                      <div class="col-6">
                        <label for="street-name-2" class="fontStyle"> {{$t('enterprise_profile_street_name_2_label')}}</label>
                        <input type="text" class="form-control height-50" v-model="streetNameTwoOptional" :disabled="isDisabled"
                               :class="editable && streetNameTwoOptionalError ? 'errClass':''"/>
                      </div>
                    </div>
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <div class="row">
                          <div class="col-6 pr-4">
                            <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_city_label')}}</label>
                            <input type="text" class="form-control height-50" v-model="enterpriseCityOneOptional" :disabled="isDisabled"
                                   :class="editable && enterpriseCityOneOptionalError ? 'errClass':''"/>
                          </div>
                          <div class="col-6">
                            <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_state_label')}}</label>
                            <input type="text" class="form-control height-50" v-model="enterpriseStateOneOptional" :disabled="isDisabled"
                                   :class="editable && enterpriseStateOneOptionalError ? 'errClass':''"/>
                          </div>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="row">
                          <div class="col-6 pr-4">
                            <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_postal_code_label')}}</label>
                            <input type="text" class="form-control height-50" v-model="enterprisePostalCodeOneOptional" :disabled="isDisabled"
                                   @keypress="validateNumber"/>
                          </div>
                          <div class="col-6">
                            <label for="street-name-1" class="fontStyle"> {{$t('enterprise_profile_country_label')}}</label>
                            <select  class='form-control height-50' v-model="enterpriseCountryOneOptional" :disabled="isDisabled"
                                     :class="editable && enterpriseCountryOneOptionalError ? 'errClass':''" name="" id="">
                              <option value="default" disabled selected>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                              </option>
                              <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                                  countryName(country)
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="headerDiv">
                  <h5 class="contactHeading tickMargin mt-3 mb-2">
                    {{ $t('enterprise_profile_contact_information_heading') }}
                  </h5>
                  <div class="">
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <label for="general-mail" class="fontStyle"> {{$t('enterprise_profile_general_email_label')}}</label>
                        <input type="email" class="form-control height-50" v-model="generalEmail" :disabled="isDisabled"
                               @keyup="validateEmail(generalEmail)" :class="editable && generalEmailError ? 'errClass':''"/>
                      </div>
                      <div class="col-6">
                        <label for="phone-number" class="fontStyle"> {{$t('enterprise_profile_phone_number_label')}}</label>
                        <PhoneNumberInput :phoneNumber="phoneNumber" :onPhoneNumberChange="onChangePhoneNumber" :disabled="isDisabled"
                                          :validate="enterprisePhoneValidate" class="form-control inputStylePhone height-50"
                        :class="editable && enterprisePhoneErrorColor ? 'errClass':''"/>
                      </div>
                    </div>
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <label for="street-name-2" class="fontStyle"> {{$t('enterprise_profile_website_label')}}</label>
                        <input type="text" class="form-control height-50" v-model="website" :disabled="isDisabled"
                               :class="editable && websiteError ? 'errClass':''"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="headerDiv">
                  <h5 class="contactHeading tickMargin mt-3 mb-2">
                    {{ $t('enterprise_profile_enterprise_account_owner_heading') }}
                  </h5>
                  <div class="">
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <label for="general-mail" class="fontStyle"> {{$t('enterprise_profile_first_name_label')}}</label>
                        <input type="email" class="form-control height-50" v-model="ownerFirstName" :disabled="isDisabled"
                               :class="editable && ownerFirstNameError ? 'errClass':''"/>
                      </div>
                      <div class="col-6">
                        <label for="phone-number" class="fontStyle"> {{$t('enterprise_profile_last_name_label')}}</label>
                        <input type="text" class="form-control height-50" v-model="ownerLastName" :disabled="isDisabled"
                               :class="editable && ownerLastNameError ? 'errClass':''"/>
                      </div>
                    </div>
                    <div class="form-group row mx-1">
                      <div class="col-6">
                        <label for="street-name-2" class="fontStyle"> {{$t('enterprise_profile_owner_email_label')}}</label>
                        <input type="email" class="form-control height-50" v-model="ownerEmail" disabled
                               @keyup="validateEmail(ownerEmail)"/>
                      </div>
                      <div class="col-6">
                        <div class="row">
                          <div class="col-6">
                            <label for="phone-number" class="fontStyle"> {{$t('enterprise_profile_phone_number_label')}}</label>
                            <PhoneNumberInput :phoneNumber="ownerPhoneNumber" :onPhoneNumberChange="onChangeOwnerPhoneNumber"
                                              class="form-control inputStylePhone height-50" :disabled="isDisabled"
                                              :validate="ownerPhoneValidate" :class="editable && ownerPhoneErrorColor ? 'errClass':''"/>
                          </div>
                          <div class="col-6">
                            <label for="street-name-2" class="fontStyle"> {{$t('enterprise_profile_owner_language_label')}}</label>
                            <select  class='form-control height-50' v-model="language" :disabled="isDisabled"
                                     :class="editable && languageError ? 'errClass':''" name="" id="">
                              <option value="default" disabled>{{ $t('enterprise_profile_dropdown_default_option') }}
                              </option>
                              <option v-for="(language, index) in totalLanguages" :value="language" :key="index">{{
                                  languageName(language)
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </form>
            </div>
            <div class="modal-footer" v-if="editable">

                <button type="button" class="btn btn-light-secondary" @click="cancelChanges">
                  <em class="bx bx-x d-block d-sm-none"></em>
                  <span class="d-none d-sm-block " style="color: white" >{{
                      $t('clo_user_view_cancel_button')
                    }}</span>
                </button>

              <button type="button" class="btn btn-primary ml-1" @click="saveData">
                <em class="bx bx-check d-block d-sm-none"></em>
                <span class="d-none d-sm-block" >{{ $t('enterprise_profile_save_button')
                  }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import { getLanguageName } from "@/app-assets/js/get-language.js";
import Alert from "@/components/Alerts";
export default {
  name: "EnterpriseProfile",
  data() {
    return {
      streetNameOne:'',
      streetNameTwo:'',
      enterpriseCityOne:'',
      enterpriseStateOne:'',
      enterprisePostalCodeOne:'',
      tickIcon: require('@/assets/tick-mark.png').default,
      streetNameOneOptional:'',
      streetNameTwoOptional:'',
      enterpriseCityOneOptional:'',
      enterpriseStateOneOptional:'',
      enterprisePostalCodeOneOptional:'',
      enterpriseCountryOneOptional:'default',
      enterpriseCountryOne:'default',
      generalEmail:'',
      phoneNumber:0,
      ownerPhoneNumber:0,
      website:'',
      ownerFirstName:'',
      ownerLastName:'',
      ownerEmail:'',
      language:'default',
      entId: this.$route.params.ent,
      resp:[],
      isDisabled:true,
      editable:false,
      totalLanguages: [],
      totalCountries:[],
      inValidEmail:false,
      enterprisePhoneError:false,
      enterprisePhoneErrorColor:false,
      ownerPhoneErrorColor:false,
      requiredError:false,
      streetNameOneError:false,
      streetNameTwoError:false,
      enterpriseCityOneError:false,
      enterpriseStateOneError:false,
      enterpriseCountryOneError:false,
      streetNameOneOptionalError:false,
      streetNameTwoOptionalError:false,
      enterpriseCityOneOptionalError:false,
      enterpriseStateOneOptionalError:false,
      enterpriseCountryOneOptionalError:false,
      generalEmailError:false,
      websiteError:false,
      ownerFirstNameError:false,
      ownerLastNameError:false,
      languageError:false,
      data:{},
      apiError:false,
      apiErrorText:''
    }
  },
  components:{
    PhoneNumberInput,
    Alert
  },
  methods:{
    onChangePhoneNumber(value) {
      let self = this
      self.phoneNumber = value;
    },
    onChangeOwnerPhoneNumber(value){
      let self = this
      self.ownerPhoneNumber = value;
    },
     countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    languageName(element) {
      console.log("language----", element)
      if (element) {
        return getLanguageName(element);
      }
    },
    getCountries(){
      let self = this;
      self.totalCountries = ['lb','jo','pl','ua','us','ca','pe','co' ]
    },
    getLanguages(){
      let self = this;
      this.$apiCall.get(`v1/settings/languages`).then((response)=>{
        console.log("language", response.data);
        self.totalLanguages = response.data.pactoLanguages
      })
    },
    ownerPhoneValidate(telnumber) {
      console.log("enterprisePhoneValidate ", telnumber)
      let self = this
      if(telnumber.valid) {
        self.enterprisePhoneError = false;
        self.ownerPhoneErrorColor = false;
      } else {
        self.enterprisePhoneError = true;
        self.ownerPhoneErrorColor = true;
      }
    },
    editEnterpriseProfile(){
      let self = this;
      self.isDisabled = false;
      self.editable = true;
    },
     cancelChanges(){
       this.getOrganisationDetails()
    },
    validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    validateEmail(email){
      let self = this;
      if(/^[^@]+@\w+(\.\w+)+\w$/.test(email)){
        self.inValidEmail = false;
      } else {
        self.inValidEmail = true;
      }
    },
    enterprisePhoneValidate(telnumber) {
      console.log("enterprisePhoneValidate ", telnumber)
      let self = this
      if(telnumber.valid) {
        self.enterprisePhoneError = false;
        self.enterprisePhoneErrorColor = false;
      } else {
        self.enterprisePhoneError = true;
        self.enterprisePhoneErrorColor = true;
      }
    },
    isRequiredEnterpriseBusinessValidation(){
      let self = this;
      if(self.streetNameOne !=''){
        self.requiredError = false;
        self.streetNameOneError = false;
      } else {
        self.requiredError = true;
        self.streetNameOneError = true;
      }
      if(self.streetNameTwo !=''){
        self.requiredError = false;
        self.streetNameTwoError = false;
      } else {
        self.requiredError = true;
        self.streetNameTwoError = true;
      }
      if(self.enterpriseCityOne !=''){
        self.requiredError = false;
        self.enterpriseCityOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCityOneError = true;
      }
      if(self.enterpriseStateOne !=''){
        self.requiredError = false;
        self.enterpriseStateOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseStateOneError = true;
      }
      if(self.enterpriseCountryOne !='default'){
        self.requiredError = false;
        self.enterpriseCountryOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCountryOneError = true;
      }
    },
    isRequiredEnterpriseBillingValidation(){
      let self = this;
      if(self.streetNameOneOptional !=''){
        self.requiredError = false;
        self.streetNameOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.streetNameOneOptionalError = true;
      }
      if(self.streetNameTwoOptional !=''){
        self.requiredError = false;
        self.streetNameTwoOptionalError = false;
      } else {
        self.requiredError = true;
        self.streetNameTwoOptionalError = true;
      }
      if(self.enterpriseCityOneOptional !=''){
        self.requiredError = false;
        self.enterpriseCityOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCityOneOptionalError = true;
      }
      if(self.enterpriseStateOneOptional !=''){
        self.requiredError = false;
        self.enterpriseStateOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseStateOneOptionalError = true;
      }
      if(self.enterpriseCountryOneOptional !='default'){
        self.requiredError = false;
        self.enterpriseCountryOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCountryOneOptionalError = true;
      }

    },
    isRequiredEnterpriseContactInformation(){
      let self = this;
      if(self.generalEmail !=''){
        self.requiredError = false;
        self.generalEmailError = false;
      } else {
        self.requiredError = true;
        self.generalEmailError = true;
      }
       if(self.website !=''){
        self.requiredError = false;
        self.websiteError = false;
      } else {
        self.requiredError = true;
        self.websiteError = true;
      }
    },
    isRequiredEnterpriseOwnerValidation(){
      let self = this;
      if(self.ownerFirstName !=''){
        self.requiredError = false;
        self.ownerFirstNameError = false;
      } else {
        self.requiredError = true;
        self.ownerFirstNameError = true;
      }
       if(self.ownerLastName !=''){
        self.requiredError = false;
        self.ownerLastNameError = false;
      } else {
        self.requiredError = true;
        self.ownerLastNameError = true;
      }
        if(self.language !='default'){
        self.requiredError = false;
        self.languageError = false;
      } else {
        self.requiredError = true;
        self.languageError = true;
      }
    },


    saveData(){
      let self = this;
      this.isRequiredEnterpriseBusinessValidation();
      this.isRequiredEnterpriseBillingValidation();
      this.isRequiredEnterpriseContactInformation();
      this.isRequiredEnterpriseOwnerValidation();
      self.data={
        "officialBusinessAddress": {
          "street1": self.streetNameOne,
          "currentCountry": self.enterpriseCountryOne,
          "street2": self.streetNameTwo,
          "zip": self.enterprisePostalCodeOne,
          "state": self.enterpriseStateOne,
          "city": self.enterpriseCityOne
        },
        "officialBillingAddress": {
          "state": self.enterpriseStateOneOptional,
          "currentCountry": self.enterpriseCountryOneOptional,
          "street1": self.streetNameOneOptional,
          "zip": self.enterprisePostalCodeOneOptional,
          "street2": self.streetNameTwoOptional,
          "city": self.enterpriseCityOneOptional
        },
        "email": self.generalEmail,
        "officialPhoneNumber":self.phoneNumber,
        "phoneNumber":self.ownerPhoneNumber,
        "officialEmail":self.ownerEmail,
        "firstName":self.ownerFirstName,
        "lastName":self.ownerLastName,
        "officialWebsite":self.website,
        "language":self.language
      };
      if(self.editable && !self.inValidEmail && !self.enterprisePhoneError && !self.streetNameOneError && !self.streetNameTwoError && !self.enterpriseCityOneError && !self.enterpriseStateOneError
      && !self.enterpriseCountryOneError && !self.streetNameOneOptionalError && !self.streetNameTwoOptionalError && !self.enterpriseCityOneOptionalError && !self.enterpriseStateOneOptionalError
      && !self.enterpriseCountryOneOptionalError && !self.generalEmailError && !self.websiteError && !self.ownerFirstNameError && !self.ownerLastNameError && !self.languageError) {
        this.$apiCall.patch(`v1/enterpriseaccount/${self.entId}`, self.data).then((response) => {
          console.log("patch response", response);
          if(response.data){

            self.editable = false;
            self.isDisabled = true;
          }
        })
          .catch((error) => {
            self.apiError = true;
            self.apiErrorText = `<strong>Ops!</strong> ${error.response.data.message}`;
          })
      }
    },

    getOrganisationDetails(){
      let self = this;
      self.editable = false;
      self.isDisabled = true
      this.$apiCall.get(`v1/enterpriseaccount/${self.entId}`).then( (response) => {
        console.log('resppppppppp', response.data);
        self.resp = response.data;
        self.ownerEmail = self.resp.officialEmail;
        self.ownerFirstName = self.resp.firstName;
        self.ownerLastName = self.resp.lastName;
        self.streetNameOne = self.resp.officialBusinessAddress.street1;
        self.streetNameTwo = self.resp.officialBusinessAddress.street2;
        self.enterpriseCityOne = self.resp.officialBusinessAddress.city;
        self.enterpriseStateOne = self.resp.officialBusinessAddress.state;
        self.enterprisePostalCodeOne = self.resp.officialBusinessAddress.zip;
        self.enterpriseCountryOne =  self.resp.officialBusinessAddress.currentCountry
        self.streetNameOneOptional = self.resp.officialBillingAddress.street1;
        self.streetNameTwoOptional = self.resp.officialBillingAddress.street2;
        self.enterpriseCityOneOptional = self.resp.officialBillingAddress.city;
        self.enterpriseStateOneOptional = self.resp.officialBillingAddress.state;
        self.enterprisePostalCodeOneOptional = self.resp.officialBillingAddress.zip;
        self.enterpriseCountryOneOptional = self.resp.officialBillingAddress.currentCountry
        self.website = self.resp.officialWebsite;
        self.language = self.resp.language;
        self.phoneNumber = self.resp.officialPhoneNumber;
        self.ownerPhoneNumber = self.resp.phoneNumber;
        self.generalEmail = self.resp.email;
      })
    }
  },
  mounted() {
    this.getCountries()
    this.getLanguages()
    this.getOrganisationDetails()
  }
}
</script>

<style scoped>
.headerDiv {
  border-top: 1px solid rgba(189, 190, 190, 0.5);
}
.contactHeading {
  font-weight: 500;
  font-size: 16px;
  color: #475F7B;
  margin-left: 3px;
}
.fontStyle{
  color: #94979B;
;
}
.tickMargin {
  margin-left: 2em;
}
.titleFont{
  height: 1em;
  width: 1em;
  margin-bottom: 4px;
}
.inputStylePhone{
  border: 1px solid #DFE3E7;
  margin-left: 0em;
}
.editButtonAlign{
  margin-top: -2.5em;
}
.errClass {
  border: 1px solid red;
}

</style>
